import * as $ from 'jquery';
import 'owl.carousel';
import store from '../../js/store';

$('.testimonial, .testimonial-carousel').owlCarousel({
  items:     1,
  mouseDrag: false,
  touchDrag: true,
  nav:       true,
  dots:      false,
  loop:      false,
  autoHeight: true,
  animateOut:'fadeOut',
  animateIn: 'fadeIn',
  navText     : [
    '<svg role="presentation" title="Previous" class="icon icon--arrow_left">'+
    '<use xlink:href="/app/themes/madebrave/static/icons.svg#arrow/left"></use>'+
    '</svg>',


    '<svg role="presentation" title="Next" class="icon icon--arrow_left">'+
    '<use xlink:href="/app/themes/madebrave/static/icons.svg#arrow/right"></use>'+
    '</svg>',
  ],
  onInitialized: (function(e) {
    this.$element.addClass('owl-carousel');
    this.$element.find('.cloned').attr({
        'aria-hidden': true,
        'role'       : 'presentation',
    });

    var numItems = e.item.count,
        curItem  = (this._current - (this._clones.length / 2)) + 1;

    curItem = (curItem > numItems) ? 1 : Math.max(1,curItem);

    this.$element.find('.owl-nav .owl-prev').after('<span class="owl-count">'+curItem+' of '+numItems+'</span>');
  })
}).on('changed.owl.carousel',function(e) {
  const $elem    = $(this),
        $data    = $elem.data('owl.carousel');

  var numItems = e.item.count,
      curItem  = ($data._current - ($data._clones.length / 2)) + 1;

  curItem = (curItem > numItems) ? 1 : Math.max(1,curItem);

  $elem.find('.owl-nav .owl-count').html(curItem+' of '+numItems);
});
